import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translateLang from './lang.js'
Vue.use(VueI18n)

function loadLocaleInfo() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
const locale = translateLang(navigator.language, navigator.userLanguage)
const i18n = new VueI18n({
  locale,
  messages: loadLocaleInfo(),
  silentTranslationWarn: true
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js